export const reportConstants = {
    PUBLISH_REPORT_DATA: 'PUBLISH_REPORT_DATA',

    GET_REPORT_PUBLISHING_CRON_MODE_STARTED: "GET_REPORT_PUBLISHING_CRON_MODE_STARTED",
    GET_REPORT_PUBLISHING_CRON_MODE_SUCCESS: "GET_REPORT_PUBLISHING_CRON_MODE_SUCCESS",
}

export default reportConstants;